var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "search",
      class: { "search_size-small": _vm.size === "small" },
    },
    [
      _c(
        "el-select",
        {
          attrs: {
            multiple: "",
            filterable: "",
            "filter-method": _vm.saveEnteredValue,
            "allow-create": "",
            "default-first-option": "",
            "popper-class": "hide-dropdown",
            "popper-append-to-body": false,
            placeholder: _vm.placeholder,
          },
          on: { change: _vm.searchHandle },
          model: {
            value: _vm.value,
            callback: function ($$v) {
              _vm.value = $$v
            },
            expression: "value",
          },
        },
        _vm._l(_vm.options, function (item) {
          return _c("el-option", {
            key: item.value,
            attrs: { label: item.label, value: item.value },
          })
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.searchByClickButton.apply(null, arguments)
            },
          },
        },
        [
          _c("img", {
            attrs: {
              src: require("../../assets/icons/i_search.svg"),
              alt: "search",
            },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }